//
//
//
//
//
//
//
//
//

export default {
  name: 'pop-tips',
  props: {
    isShow: {
      type: Boolean,
      default: false,
    },
    placement: {
      type: String,
      default: 'top',
    },
    gutter: {
      type: Number,
      default: 0,
    },
    content: String | Number,
    targetWidth: String | Number,
  },
  data(){
    return {
      position: {
        left: 0,
        top: 0,
      },
      styles: {},
    };
  },
  watch: {
    isShow(cur){
      if(cur){
        this.$nextTick(() => {
          this.resolvePosition();
        });
      }
    },
  },
  methods: {
    /** 提示框显示位置处理 */
    resolvePosition(){
      const boxRef = this.$refs.tipsBox;
      const arrowRef = this.$refs.downArrow;
      const winWidth = document.documentElement.offsetWidth;
      let oldLeft = -(boxRef.offsetWidth - this.targetWidth) / 2;

      switch (this.placement){
        case 'top':
          let curTop = -(boxRef.offsetHeight + arrowRef.offsetHeight + this.gutter);

          /*this.styles.left = oldLeft + 'px';   // 先设置提示框的left值，下面再做微调

          const rectLeft = boxRef.getBoundingClientRect().left;
          const rectRight = boxRef.getBoundingClientRect().right;
          let newLeft = 0;

          // 提示框显示超出右边界
          if(rectRight > winWidth){
            let subLeft = rectRight - winWidth;

            newLeft = oldLeft - subLeft;

            // 提示框显示超出左边界
          }else if(rectLeft < 0){
            newLeft = oldLeft - rectLeft;
          }else {
            newLeft = oldLeft;
          }*/

          this.position.top = parseInt(curTop);
          this.position.left = parseInt(oldLeft);

          break;
        default: break;
      }

      this.styles = {
        visibility: 'hidden',
        left: this.position.left + 'px',
        top: this.position.top + 'px',
      };

      // 如果显示框越界了，做如下微调
      setTimeout(() => {
        const rectLeft = boxRef.getBoundingClientRect().left;
        let newLeft = 0;

        // 提示框显示超出右边界
        if(rectLeft + boxRef.offsetWidth > winWidth){
          let subLeft = rectLeft + boxRef.offsetWidth - winWidth;

          newLeft = oldLeft - subLeft - 10;
          arrowRef.style.marginLeft = '25px';  // 箭头偏移调整

        // 提示框显示超出左边界
        }else if(rectLeft < 0){
          newLeft = oldLeft - rectLeft + 10;
          arrowRef.style.marginLeft = '-20px';  // 箭头偏移调整
        }else {
          newLeft = oldLeft;
        }

        this.styles.left = newLeft + 'px';
        this.styles.visibility = 'visible';
      }, 20);

    },
  },
}



// WEBPACK FOOTER //
// ./src/components/PopTips/PopTips.vue